"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseButton = void 0;

var _react = _interopRequireDefault(require("react"));

var _atoms = require("../../atoms");

var _RoundButton = require("../RoundButton");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
var CloseButton = function CloseButton(_ref) {
  var className = _ref.className,
      onClick = _ref.onClick;
  var cname = 'CloseButton';

  if (className) {
    cname += ' ' + className;
  }

  return /*#__PURE__*/_react.default.createElement(_RoundButton.RoundButton, {
    trkAction: "Close Pressed",
    className: cname,
    icon: _atoms.Icon.Type.Close,
    color: _atoms.Color.Transparent,
    backgroundColor: _atoms.Color.Transparent,
    iconColor: _atoms.Color.Grey3,
    iconSize: 24,
    onClick: onClick,
    width: 40,
    height: 40
  });
};

exports.CloseButton = CloseButton;